import React, { FC, MouseEvent } from 'react';
import { IconName } from '../../../Icon';
import { Button } from '../../../Button/Button';

interface BulkActionButtonProps {
  disabled?: boolean;
  dataTest?: string;
  onClick(event: MouseEvent): void;
  startIcon?: IconName;
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
}

export const BulkActionButton: FC<React.PropsWithChildren<BulkActionButtonProps>> = ({
  children,
  startIcon,
  dataTest,
  disabled,
  onClick,
  color
}) => (
  <Button
    variant="outlined"
    style={{ textTransform: 'none', fontWeight: 400 }}
    startIcon={startIcon}
    disabled={disabled}
    dataTest={dataTest}
    onClick={onClick}
    color={color}
  >
    {children}
  </Button>
);
